import React from 'react'
import { css } from '@emotion/react'
import { Card, colors, font, mq } from 'plume-ui'
import { FinanceNewsData } from '../../../../../types/api'
import { useUser } from '../../../../../contexts/AuthContext'
import { CardInnerTitle } from '../../../../atoms/CardInnerTitle'
import { EmptyCard } from '../../../../common/EmptyCard'
import { isEnterpriseWithTrial } from '@/lib/user'
import { A } from '../../../../atoms/A'
import { IGNORED_BY_WOVN_CLASS_NAME } from '@/lib/wovn'
import { FormattedDate } from '../../../../atoms/FormattedDate'

type Props = {
  financeNews: FinanceNewsData[]
}

export const CompanyFinanceNewsList: React.FC<Props> = (props) => {
  const user = useUser()

  return (
    <Card>
      <CardInnerTitle title="資金調達・提携ニュース" />
      {props.financeNews.length === 0 ? (
        <EmptyCard />
      ) : (
        props.financeNews.map((news, i) => {
          const path = isEnterpriseWithTrial(user)
            ? news.path
            : news.externalUrl
          return (
            <div
              css={css`
                padding: 15px 20px;
                border-bottom: 1px solid ${colors.gray50};
                ${mq.large} {
                  display: flex;
                }
              `}
              key={i}
            >
              <div
                css={css`
                  display: flex;
                  align-items: center;
                  white-space: nowrap;
                  ${mq.large} {
                    flex-basis: 160px;
                  }
                `}
              >
                <span
                  css={css`
                    font-size: 14px;
                    letter-spacing: 0.8px;
                    font-weight: ${font.weight.bold};
                    color: ${colors.textLight};
                    margin-right: 10px;
                  `}
                >
                  {news.category}
                </span>
                <span
                  css={css`
                    font-size: 14px;
                    color: ${colors.textLight};
                  `}
                  className={IGNORED_BY_WOVN_CLASS_NAME}
                >
                  <FormattedDate>{news.publishedAt}</FormattedDate>
                </span>
              </div>
              <div
                css={css`
                  font-size: 14px;
                  font-weight: ${font.weight.bold};
                  line-height: 1.4;
                  margin-top: 5px;
                  ${mq.large} {
                    flex: 1;
                  }
                `}
              >
                <A
                  href={path}
                  target="_blank"
                  rel="noopener"
                  decoration="none"
                  css={css`
                    color: ${colors.black30};
                    transition: 0.3s;
                    &:hover {
                      text-decoration: underline;
                    }
                  `}
                >
                  {news.title}
                </A>
              </div>
            </div>
          )
        })
      )}
    </Card>
  )
}
